import React from "react";
import classNames from "../../classNames";

function Item({ className, onClick, children, disabled }) {
  return (
    <li className={classNames(className, "page-item")}>
      <button
        type="button"
        className="page-link shadow-none"
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </button>
    </li>
  );
}

export default Item;
